import { Injectable } from '@angular/core';

export interface IGADeferred<T> {
  promise: Promise<T>;
  resolve(arg?: T): void;
  reject(arg?: T): void;
  cancelled?:boolean;
}

@Injectable()
export class GaDeferredService {
  public defer<T>(): IGADeferred<T> {
    let resolve:(value?:T|PromiseLike<T>) => void;
    let reject:(reason?:any) => void;

    const promise: Promise<T> = new Promise((res, rej) => {
      [resolve, reject] = [res, rej];
    });

    return { promise, reject, resolve };
  }
}